import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast } from '../../../utils/toastUtils';
import { useClient } from '../../client-api';
import { type AdvisoryNeedTaskDto, type AdvisoryNeedTaskUpdateDto, updateAdvisoryNeedTask } from '../../generated/client';
import { queryKeys } from '../../query-keys';

interface IUpdateAdvisoryNeedTaskParams {
    taskId: number;
    task: AdvisoryNeedTaskUpdateDto;
}

export const useUpdateAdvisoryNeedTask = (): UseMutationResult<AdvisoryNeedTaskDto, AxiosError, IUpdateAdvisoryNeedTaskParams> => {
    const { t } = useTranslation();

    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (payload) => updateAdvisoryNeedTask({ path: { id: payload.taskId }, body: payload.task }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.advisoryNeedTasks(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.events(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.notifications() });
            queryClient.invalidateQueries({ queryKey: queryKeys.notificationsForClient(client?.id) });
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
};
